<script setup></script>

<template>
  <div>Not found page</div>
</template>

<style scoped></style>
